angular.module('wbControllers').controller('PasswordController',
  ['$scope', '$rootScope', '$location', 'users', ($scope, $rootScope, $location, users) => {
    $scope.user = {};
    $scope.user.resetPasswordToken = $location.search().token;
    $scope.tries = 0;

    const update = form => {
      $scope.user.passwordConfirmation = $scope.user.password;
      if (!$scope.passwordStrength.accepted) {
        $scope.error = 'Please make sure all the new password requirements are met.';
        // To give time for the error message to show up before we recalculate the tool tip position
        setTimeout(() => $("[pwr-ref='change-pw'][name='password']").focus(), 100);
        return $scope.error;
      }
      $scope.error = '';
      return users.updatePassword($scope.user)
        .then(() => {
          if ($scope.passwordDialog != null) {
            $scope.passwordDialog.hide();
          }
          $scope.success = true;
          $scope.user = {};
          form.$setPristine();
          if (!$scope.auth.isSignedIn) {
            window.location = '/';
          }
        }).catch(e => {
          if ((e.data != null ? e.data.message : undefined)) {
            $scope.error = e.data.message.replace('\n', '<br \\>');
          } else {
            $scope.error = "An unexpected error occurred. We're working to resolve it.";
          }
          return $scope.error;
        });
    };

    $scope.updatePassword = (form) => {
      $scope.state = 'submitting';
      return update(form);
    };

    $scope.resetPassword = function () {
      let sendingPasswordReset = null;
      $scope.success = null;
      $scope.error = null;
      $scope.message = null;
      if (sendingPasswordReset) return;
      sendingPasswordReset = true;
      return users.resetPassword($scope.user)
        .then(() => {
          sendingPasswordReset = false;
          $scope.message = "A password reset e-mail has been sent, please check your inbox.";
        }).catch(() => {
          sendingPasswordReset = false;
          $scope.message = (e.data != null ? e.data.message : undefined) || "An unexpected error occurred. We're working to resolve it.";
        });
    };
    return $scope.resetPassword;
  }
  ]);
